import BaseService from './BaseService';

export interface CreateProps {
  store_id: number;
  order_type: number;
  store_table_id: number | null;
}

export interface ShowProps {
  cart_id: number;
  store_id: number;
  order_type: number;
}

export interface StepsAndComplementsProps {
  store_id: number;
  product_id: number;
  order_type: number;
}

export interface GuestProps {
  store_id: number;
  order_type: number;
}

export interface GuestCartProps {
  store_id: number;
  // order_type_id?: number;
  order_type: number;
  zipcode?: number;
  number?: number;
  lat?: number;
  lng?: number;
}

export interface RemoveAllProps {
  order_type: number;
}

export interface CouponProps {
  coupon_code: string;
  order_type: number;
  store_id: number;
}

export interface ChangeQuantityProps {
  id: number;
  order_type: number;
  quantity: number;
}

export interface DeleteProductFromCartProps {
  id: number;
  order_type: number;
}

export interface UpdateCartTableProps {
  cart_id: number;
  order_type: number;
  store_id: number;
  store_table_id: number | null;
}

export interface AddProductProps {}

export default class CartService {
  baseService: BaseService;
  ApiBaseService: BaseService;

  constructor(orderType: string) {
      this.baseService = new BaseService(orderType);
      this.ApiBaseService = new BaseService('');
    }

  async create(payload: CreateProps): Promise<any> {
    try {
      const response = await this.baseService.http.post<{ payload: CreateProps }>('cart/create', payload);
      return response.data;
    } catch (error) {
      console.error('Erro create:', error);
      throw error;
    }
  }

  async addProduct(cartId: number, payload: AddProductProps): Promise<any> {
    try {
      const response = await this.baseService.http.post<{ payload: AddProductProps }>(`cart/${cartId}/add`, payload);
      return response.data;
    } catch (error) {
      console.error('Erro addProduct:', error);
      throw error;
    }
  }

  async show(params: ShowProps): Promise<any> {
    try {
      const response = await this.baseService.http.get<{ params: ShowProps }>(`cart/${params.cart_id}/show?store_id=${params.store_id}&order_type=${params.order_type}`);

      return response.data;
    } catch (error: any) {
      console.error(error);
      throw error;
    }
  }

  async stepsAndComplements(params: StepsAndComplementsProps): Promise<any> {
    try {
      const response = await this.baseService.http.get<{ params: StepsAndComplementsProps }>(`products/composite/steps?store_id=${params.store_id}&product_id=${params.product_id}&order_type=${params.order_type}`);
      return response.data;
    } catch (error: any) {
      console.error(error);
      throw error;
    }
  }

  async guestToken(payload: GuestProps): Promise<any> {
    try {
      const response = await this.ApiBaseService.http.post<{ payload: GuestProps }>(`cart/guest`, payload);
      return response.data;
    } catch (error) {
      console.error('guestToken:', error);
      throw error;
    }
  }

  async getActiveCart(params: GuestCartProps): Promise<any> {
    try {
      
      const { store_id, order_type, zipcode, number, lat, lng } = params;

      // Cria o objeto com todos os parâmetros possíveis
      const queryParams: Record<string, string | undefined> = {
        store_id: String(store_id),
        order_type: String(order_type),
        zipcode: zipcode ? String(zipcode) : undefined,
        number: number ? String(number) : undefined,
        lat: lat ? String(lat) : undefined,
        lng: lng ? String(lng) : undefined,
      };

      // Filtra apenas os valores definidos e cria os search params
      const searchParams = new URLSearchParams(
        Object.entries(queryParams).filter(([, v]) => v !== undefined) as [string, string][]
      );

      const url = `cart?${searchParams.toString()}`;
      const response = await this.baseService.http.get<{ params: GuestCartProps }>(url);
      return response.data;

    } catch (error: any) {
      console.error('Erro getActiveCart:', error);
      throw error;
    }
  }

  async removeAll(cart_id: number, payload: RemoveAllProps): Promise<any> {
    try {
      const response = await this.baseService.http.post<{ payload: RemoveAllProps }>(`cart/${cart_id}/remove-all`, payload);
      return response.data;
    } catch (error) {
      console.error('Erro removeAll:', error);
      throw error;
    }
  }

  async applyCoupon(cart_id: number, payload: CouponProps): Promise<any> {
    try {
      const response = await this.ApiBaseService.http.post<{ payload: CouponProps }>(`cart/${cart_id}/apply-coupon`, payload);
      return response.data;
    } catch (error) {
      console.error('Erro applyCoupon:', error);
      throw error;
    }
  }

  async removeCoupon(cart_id: number, payload: CouponProps): Promise<any> {
    try {
      const response = await this.ApiBaseService.http.post<{ payload: CouponProps }>(`cart/${cart_id}/remove-coupon`, payload);
      return response.data;
    } catch (error) {
      console.error('Erro removeCoupon:', error);
      throw error;
    }
  }
  
  async changeQuantity(cart_id: number, payload: ChangeQuantityProps): Promise<any> {
    try {
      const response = await this.baseService.http.post<{ payload: ChangeQuantityProps }>(`cart/${cart_id}/change-quantity`, payload);
      return response.data;
    } catch (error) {
      console.error('Erro changeQuantity:', error);
      throw error;
    }
  }
  
  async deleteProductFromCart(cart_id: number, payload: DeleteProductFromCartProps): Promise<any> {
    try {
      const response = await this.baseService.http.post<{ payload: DeleteProductFromCartProps }>(`cart/${cart_id}/remove`, payload);
      return response.data;
    } catch (error) {
      console.error('Erro deleteProductFromCart:', error);
      throw error;
    }
  }

  async updateCartTable(cart_id: number, payload: UpdateCartTableProps): Promise<any> {
    try {
      const response = await this.baseService.http.post<{ payload: UpdateCartTableProps }>(`cart/update/${cart_id}`, payload);
      return response.data;
    } catch (error) {
      console.error('Erro updateCartTable:', error);
      throw error;
    }
  }

}
